import { WindTurbineName } from "./WindTurbineName";
export default WindTurbineName;
